export enum TVehicleIdentifier {
  REGISTRATION = 'REGISTRATION',
  ILAN = 'ILAN',
}

export type VehicleIdentifier = {
  type: TVehicleIdentifier
  value: string
}
